import { render, staticRenderFns } from "./cis.vue?vue&type=template&id=968d7884&scoped=true"
import script from "./cis.vue?vue&type=script&lang=js"
export * from "./cis.vue?vue&type=script&lang=js"
import style0 from "./cis.vue?vue&type=style&index=0&id=968d7884&prod&lang=less&scoped=true"
import style1 from "./cis.vue?vue&type=style&index=1&id=968d7884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968d7884",
  null
  
)

export default component.exports